import { useEffect } from "react";

import { useSetProfileData }                         from "_common/hooks/auth";
import { initialValidations }                        from "_common/ssrWrapper";
import CreatorPlusPage                               from "_components/pages/creatorPlus";
import { useSetPreviousPath }                        from "_jotai/rooterPro";
import { getCreatorPlusPlans, getUserPlusPlan }      from "_services/api/creator-plus";
import { getProPlans, getUserProPlan, getUserRoles } from "_services/api/pro";
import { getUserProfile }                            from "_services/api/user";

function component ( props ) {
	const setUserProfile  = useSetProfileData ();
	const setPreviousPath = useSetPreviousPath ();

	useEffect ( () => {
		setPreviousPath ( props.previousPath );

		if ( props?.isWebview && props?.profile !== null ) {
			setUserProfile ( props?.profile );
		}
	}, [ props.previousPath ] );

	return (
		<CreatorPlusPage
			emotionCache = { props.emotionCache }
			error        = { props?.error }
			from         = "ProPage"
			initialOpen  = { true }
			isProStatus  = { props?.isPlus }
			isWebView    = { props?.isWebview }
			plans        = { props?.plans }
			proDetails   = { props?.proDetails }
		/>
	);
}

export default component;

const getServerSideProps = context => initialValidations ( context, async defaultProps => {

	// redirect to open modal if the user opens pro page on desktop
	if ( !defaultProps?.isMobile )
		return {
			redirect: {
				destination : "/?plusModal=true",
				permanent   : false
			}
		};

	const userId = defaultProps?.userAuth?.userId;

	// this case will never happen in android webview since we are always logged in in webview
	// all the logged out user will be redirected to pro page if they come to already-pro page
	if ( !userId && context.query.alreadyPlus === "true" )
		return {
			redirect: {
				destination : "/creator-plus",
				permanent   : false
			}
		};

	const countryCode = defaultProps.viewerCountry;

	const apiCalls = [
		getCreatorPlusPlans.bind ( defaultProps ) ( { countryCode, screen: "serverSide" } )
	];

	if ( userId )
		apiCalls.push (
			getUserPlusPlan.bind ( defaultProps ) ()
		);

	// if the user is in webiew and opens pro page then update the profile too
	if ( defaultProps?.isWebView )
		apiCalls.push (
			getUserProfile.bind ( defaultProps ) ( { userId } )
		);

	const results = await Promise.allSettled ( apiCalls );
	let plans     = [], currentPlan = null, profile = {}, roles = [];

	try {
		// get user roles only if user is logged in
		if ( defaultProps?.userAuth?.userId && defaultProps?.userAuth?.userId !== "null" ) {
			roles        = await getUserRoles.bind ( defaultProps ) ();
			const isPlus = roles?.some ( element => {
				if ( element.typeId === 2 ) // typeId 2 is for creator-plus
					return true;
			} );

			// if the user is pro and opens the pro page the redirect them to already-pro page
			if ( isPlus && context.query.alreadyPlus
				 !== "true" ) {
				const params = encodeURI ( new URLSearchParams ( context.query ).toString () );

				if ( !context.query.forceOpen )
					return {
						redirect: {
							destination : `/creator-plus?alreadyPlus=true&${ params }`,
							permanent   : false
						}
					};
			}

			// if the user is in webiew and opens pro page then update the profile too
			if ( defaultProps.isWebview ) {
				profile = await getUserProfile.bind ( defaultProps ) ( { userId: defaultProps.userAuth.userId } );
			}
		}

	} catch ( error ) {
		// console.log ( "========  error:", _error ( error ) );
	}

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					plans = result.value;
					break;

				case 1:
					currentPlan = result.value;
					break;

				case 2:
					profile = result.value;
					break;

			}
		}
	} );

	/* if ( !plans?.length )
		return {
			props: {
				...defaultProps,
				error       : true,
				noAuth      : defaultProps?.isWebview ? true : false,
				noLayout    : true,
				noAnalytics : true
			}
		}; */

	const isPlus = currentPlan?.status === "ACTIVE" || false;

	// if the user is pro and opens the pro page the redirect them to already-pro page
	if ( isPlus && context.query.alreadyPlus !== "true" ) {
		const params = encodeURI ( new URLSearchParams ( context.query ).toString () );

		if ( !context.query.forceOpen )
			return {
				redirect: {
					destination : `/creator-plus?alreadyPlus=true&${ params }`,
					permanent   : false
				}
			};
	}

	return {
		props: {
			...defaultProps,
			plans,
			isPlus,
			profile     : profile || null,
			proDetails  : currentPlan,
			noAuth      : defaultProps?.isWebview ? true : false,
			forceTheme  : "dark",
			noLayout    : true,
			noAnalytics : true
		}
	};

} );

export { getServerSideProps };
